import {
  GET_CLIENT_SUMMARY,
  GET_CLIENT_SUMMARY_SUCCESS,
  SAVE_CLIENT_SUMMARY,
  CLIENT_SUMMARY_ERROR,
} from './types';

// servicePlan
const initialState = {
  item: null,
  notifications: [],
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CLIENT_SUMMARY:
    case SAVE_CLIENT_SUMMARY:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_CLIENT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case CLIENT_SUMMARY_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
